export default __webpack_public_path__ + "static/media/EasyGo_Trailer.26645ea0.gif";